<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useSession, signOut } from '@/auth';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu';
import { Settings, LogOut, User } from 'lucide-vue-next';

const router = useRouter();
const session = useSession();
const user = computed(() => session.value?.data?.user);

async function handleSignOut() {
  try {
    await signOut();
    router.push('/sign-in');
  } catch (e) {
    console.error('Sign out failed:', e);
  }
}

function goToHome() {
  router.push('/');
}
</script>

<template>
  <header class="border-b border-border bg-card">
    <div class="max-w-4xl mx-auto px-4 py-4 flex justify-between items-center">
      <button
        class="text-2xl font-mono font-bold text-foreground hover:text-primary transition-colors cursor-pointer"
        @click="goToHome"
      >
        LLM-SR
      </button>
      <div class="flex items-center gap-4">
        <template v-if="user">
          <Button
            variant="ghost"
            @click="router.push('/decks')"
          >
            Decks
          </Button>
          <Button
            variant="ghost"
            @click="router.push('/review')"
          >
            Review
          </Button>
          <Button
            variant="ghost"
            @click="router.push('/integrations')"
          >
            Integrations
          </Button>
          <DropdownMenu>
            <DropdownMenuTrigger as-child>
              <Button variant="ghost" size="icon">
                <User class="size-5" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem @click="router.push('/settings')">
                <Settings class="size-4" />
                Settings
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem class="text-destructive focus:text-destructive" @click="handleSignOut">
                <LogOut class="size-4" />
                Sign Out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </template>
        <template v-else>
          <Button
            variant="ghost"
            @click="router.push('/sign-in')"
          >
            Sign In
          </Button>
          <Button @click="router.push('/sign-up')">
            Sign Up
          </Button>
        </template>
      </div>
    </div>
  </header>
</template>
